<template>
  <div class="user-details-view">
    <div class="user-details-view__header">
      <h3>Detalle Usuario</h3>
    </div>
    <div v-if="!fetchingUser" v-loading="fetchingUser" class="user-details-view__content">
      <div class="user-details-view__user-info">
        <div class="user-details-view__user-item">
          <h3>{{ fullName }}</h3>
          <div>Rut: {{ user.rut }}</div>
        </div>
        <div v-if="hasOrganizations" class="user-details-view__user-item">
          <h4>Organizaciones</h4>
          <div>
            <router-link
              v-for="organization in user.organizations"
              :key="organization.uuid"
              :to="organizationDetailsRoute(organization)"
              class="badge badge-primary">
              {{ organization.name }} - {{ organization.code }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetailsView',
  data() {
    const type = this.$route.params.type === 'dispenser_admin' ? 'dispenser' : this.$route.params.type;
    return {
      type: type,
      id: this.$route.params.id,
      user: {},
      fetchingUser: true
    };
  },
  computed: {
    fullName() {
      return `${this.user.given_name} ${this.user.family_name}`;
    },
    hasOrganizations() {
      return this.user.organizations.length > 0;
    }
  },
  created() {
    this.fetchUser();
  },
  methods: {
    fetchUser() {
      this.fetchingUser = true;
      this.$store.dispatch('fetchUser', { id: this.id })
        .then(response => {
          this.user = response;
          this.fetchingUser = false;
        });
    },
    organizationDetailsRoute(organization) {
      return `/organizations/${organization.source}/${organization.uuid}`;
    }
  }
};
</script>

<style lang="scss">
.user-details-view {
  padding: $--spacing-6;

  &__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: $--spacing-6;
    margin-bottom: $--spacing-6;
    border-bottom: 1px solid $--color-light-gray;
  }

  &__user-info {
    background-color: $--color-white;
    border: 1px solid $--color-light-gray;
    padding: $--spacing-4;
    margin-bottom: $--spacing-6;

    h3 {
      font-size: $--font-size-md;
    }

    h4 {
      font-size: $--font-size-base;
    }

    .badge {
      margin-right: $--spacing-1;
    }
  }

  &__user-item:not(:last-child) {
    border-bottom: 1px solid #E6E6E6;
    padding-bottom: $--spacing-2;
    margin-bottom: $--spacing-2;
  }

  &__dependent_users {
    .users-table {
      margin-top: $--spacing-4;
      background-color: $--color-white;
    }
  }
}
</style>
